import { useState } from 'react';
import { faqs } from '@/mocks/faq';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <span className="inline-flex items-center gap-1.5 text-xs md:text-sm font-medium tracking-widest uppercase text-accent-700">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              常见问题
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mt-3 leading-snug">
              关于观看体验，你可能想知道的
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
              这里整理了大家最常问的几个问题。如果还有疑问，可以先看看下方的说明，大多数情况都能自己解决。
            </p>
            <div className="mt-6 rounded-xl bg-secondary-100/70 border border-secondary-200 p-4">
              <div className="flex items-center gap-2 text-secondary-900">
                <i className="ri-lightbulb-flash-line"></i>
                <span className="text-sm font-medium">小提示</span>
              </div>
              <p className="text-xs md:text-sm text-secondary-900/80 leading-relaxed mt-2">
                遇到卡顿时优先尝试切换播放线路或刷新页面，通常比等待缓冲更有效。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <ul className="divide-y divide-background-200/80 border-t border-b border-background-200/80">
              {faqs.map((faq) => {
                const open = openId === faq.id;
                return (
                  <li key={faq.id}>
                    <button
                      type="button"
                      aria-expanded={open}
                      onClick={() => setOpenId(open ? null : faq.id)}
                      className="w-full flex items-center justify-between gap-4 py-4 md:py-5 text-left cursor-pointer"
                    >
                      <span
                        className={`font-heading text-sm md:text-base font-semibold transition-colors ${
                          open ? 'text-primary-600' : 'text-foreground-950'
                        }`}
                      >
                        {faq.question}
                      </span>
                      <span
                        className={`w-7 h-7 flex-shrink-0 rounded-full flex items-center justify-center transition-colors ${
                          open
                            ? 'bg-primary-500 text-background-50'
                            : 'bg-background-100 text-foreground-600'
                        }`}
                      >
                        <i className={open ? 'ri-subtract-line' : 'ri-add-line'}></i>
                      </span>
                    </button>
                    {open && (
                      <p className="pb-5 pr-10 text-xs md:text-sm text-foreground-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}